import React from 'react'
import {
  CallIcon,
  DeliveryAndPaymentIcon,
  DocumentIcon,
  GalleryIcon,
  InfoIcon,
  LocationIcon,
  NewsIcon,
  PercentIcon,
  VacanciesIcon,
} from '../_assets/icon-components'
import { LuStar } from 'react-icons/lu'

export const getPage = (
  key: string
): {
  title: string
  icon: React.ReactElement
  route: string
  protected?: boolean
  type?: string
} => {
  switch (key) {
    case 'branches':
      return {
        title: 'branches',
        icon: <LocationIcon color='var(--text-muted)' />,
        route: '/branches',
      }
    case 'contacts':
      return {
        title: 'contacts',
        icon: <CallIcon color='var(--text-muted)' />,
        route: '/contacts',
      }
    case 'delivery_and_payment':
      return {
        title: 'delivery_and_payment',
        icon: <DeliveryAndPaymentIcon color='var(--text-muted)' />,
        route: '/delivery',
      }
    case 'about_us':
      return {
        title: 'about',
        icon: <InfoIcon color='var(--text-muted)' />,
        route: '/about',
      }
    case 'reservations':
      return {
        title: 'reservations',
        icon: <InfoIcon color='var(--text-muted)' />,
        route: '/reservations',
        protected: true,
      }
    case 'vacancies':
      return {
        title: 'vacancies',
        icon: <VacanciesIcon color='var(--text-muted)' />,
        route: '/vacancies',
      }
    case 'sale':
      return {
        title: 'sale',
        icon: <PercentIcon color='var(--text-muted)' />,
        route: '/sale',
      }
    case 'news':
      return {
        title: 'news',
        icon: <NewsIcon color='var(--text-muted)' />,
        route: '/news',
      }
    case 'events':
      return {
        title: 'gallery',
        icon: <GalleryIcon color='var(--text-muted)' />,
        route: '/gallery',
      }
    case 'reviews':
      return {
        title: 'leave_feedback',
        icon: <LuStar color='var(--text-muted)' />,
        route: '/reviews',
        protected: true,
      }
    default:
      return {
        title: key,
        icon: <DocumentIcon color='var(--text-muted)' />,
        route: '/pages/' + key,
        type: 'dynamic',
      }
  }
}
